<template>
  <div class="yhc-service-level-feedback-form">
    <div class="yhc-service-level-feedback-form__header">
      <div class="yhc-service-level-feedback-form__title-row">
        <h5 class="yhc-service-level-feedback-form__title mb-0">質問・要望の投稿</h5>
        <span class="yhc-service-level-feedback-form__title-note text-danger">
          ※サービスレベル検索に関する質問・要望があれば入力してください
        </span>
      </div>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        :disabled="submitting"
        @click="handleClose"
      />
    </div>
    <div class="mb-3">
      <label class="form-label fw-bold">所属部署 <span class="text-danger">*</span></label>
      <input
        v-model="department"
        type="text"
        class="form-control"
        maxlength="200"
        :disabled="submitting"
      />
    </div>
    <div class="mb-3">
      <label class="form-label fw-bold">名前 <span class="text-danger">*</span></label>
      <input
        v-model="authorName"
        type="text"
        class="form-control"
        maxlength="100"
        :disabled="submitting"
      />
    </div>
    <div class="mb-3">
      <label class="form-label fw-bold">質問・要望内容 <span class="text-danger">*</span></label>
      <YhcServiceLevelFeedbackRichText v-model="content" />
    </div>
    <div class="d-flex justify-content-end gap-2">
      <button
        type="button"
        class="btn btn-secondary"
        :disabled="submitting"
        @click="handleClose"
      >
        閉じる
      </button>
      <button
        type="button"
        class="btn btn-primary"
        :disabled="submitting"
        @click="handleSubmitClick"
      >
        {{ submitting ? '投稿中...' : '投稿' }}
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import YhcServiceLevelFeedbackRichText from './YhcServiceLevelFeedbackRichText.vue'
import {
  ServiceLevelFeedbackSubmitError,
  submitServiceLevelFeedback,
} from '../submitServiceLevelFeedback'
import { hasServiceLevelFeedbackContent } from '../serviceLevelFeedbackSanitize'
import { openServiceLevelFeedbackSuccessModal } from '../openServiceLevelFeedbackSuccessModal'

export default defineComponent({
  name: 'YhcServiceLevelFeedbackFormModal',
  components: {
    YhcServiceLevelFeedbackRichText,
  },
  props: {
    modalId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      department: '',
      authorName: '',
      content: '',
      submitting: false,
    }
  },
  methods: {
    handleClose() {
      if (this.modalId) {
        $core.$modals.closeModal(this.modalId)
      }
    },
    async handleSubmitClick() {
      if (this.submitting) return

      const department = this.department.trim()
      const author_name = this.authorName.trim()
      if (!department || !author_name || !hasServiceLevelFeedbackContent(this.content)) {
        $core.$toast.errorToast('必須項目を入力してください')
        return
      }

      const confirmed = await $core.$toast.confirmDialog(
        '入力内容で投稿します。よろしいですか？',
      )
      if (!confirmed) return

      this.submitting = true
      try {
        await submitServiceLevelFeedback({
          department,
          author_name,
          content: this.content,
        })
        this.handleClose()
        openServiceLevelFeedbackSuccessModal()
      } catch (e) {
        const message =
          e instanceof ServiceLevelFeedbackSubmitError
            ? e.message
            : '投稿に失敗しました。しばらくしてから再度お試しください'
        $core.$toast.errorToast(message)
        console.error('[YhcServiceLevelFeedback]', e)
      } finally {
        this.submitting = false
      }
    },
  },
})
</script>

<style scoped lang="scss">
.yhc-service-level-feedback-form {
  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
    margin: calc(-1 * var(--bs-modal-padding, 1rem))
      calc(-1 * var(--bs-modal-padding, 1rem)) 1rem;
    padding: var(--bs-modal-padding, 1rem);
    border-bottom: var(--bs-modal-header-border-width, 1px) solid
      var(--bs-modal-header-border-color, var(--bs-border-color));
  }

  &__title-row {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 8px;
  }

  &__title {
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.5;
  }

  &__title-note {
    font-size: 14px;
    font-weight: 400;
    line-height: 1.5;
  }

  .form-label {
    font-size: 14px;
    margin-bottom: 4px;
  }
}
</style>
